export * from './lib/ui-generic-list.module';
export * from './lib/generic-list/generic-list.component';
export * from './lib/+state/generic.actions';
export * from './lib/+state/generic.selectors';
